<template>
  <div class="duration-300 @container/chat min-h-full">
    <!-- Content -->
    <div class="content h-full overflow-hidden w-full mx-auto">
      <div
        v-if="
          (v2ResponseStore.messages?.length || activeConversationId) &&
          !v2ResponseStore.recentConversationsOpen
        "
        class="h-full"
      >
        <transition
          mode="out-in"
          enter-from-class="-translate-x-4 opacity-20"
          enter-to-class="opacity-100"
          leave-from-class="opacity-50"
          leave-to-class="opacity-0"
          enter-active-class="duration-300"
          leave-active-class="duration-75"
        >
          <V2ConversationWrapper
            :key="activeConversationId"
            :messages="messages?.messages || []"
            :is-recent="!!activeConversationId"
            :loading="isLoading"
            :conversation-id="activeConversationId"
            :error="isError"
            @retry="refetch"
          />
        </transition>
        <!-- <DefaultConversationView v-else /> -->
      </div>
      <transition
        enter-from-class="-left-7 opacity-0"
        enter-to-class="opacity-100"
        leave-to-class="opacity-20 -left-7"
      >
        <RecentConversationList
          v-if="v2ResponseStore.recentConversationsOpen"
          @close="v2ResponseStore.toggleRecentConversations(false)"
          @start-new="startNewConversation"
        />
        <DefaultConversationView
          v-else-if="!activeConversationId && !v2ResponseStore.lastMessage"
          @show-recents="toggleConversationList(true)"
        />
      </transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import V2ConversationWrapper from "./conversation/V2ConversationWrapper.vue";
import RecentConversationList from "./conversation/RecentConversationList.vue";
import DefaultConversationView from "./conversation/DefaultConversationView.vue";

const v2ResponseStore = useV2ResponseStore();
const activeConversationId = computed(() => v2ResponseStore.lastConversationId);

const {
  data: messages,
  isLoading,
  isError,
  refetch,
} = useV2SingleConversationDetailsRequest(activeConversationId);

function startNewConversation() {
  v2ResponseStore.startNewConversation();
  v2ResponseStore.toggleRecentConversations(false);
}

function toggleConversationList(open: boolean | undefined = undefined) {
  v2ResponseStore.toggleRecentConversations(open);
  v2ResponseStore.isNewConversation = false;
}

onBeforeMount(() => {
  if (!activeConversationId.value && !v2ResponseStore.isNewConversation)
    v2ResponseStore.isNewConversation = true;
});
</script>
